export default {
    color: '#efb95e',
    urls: ['/about-programs', '/moken-labs', '/future-founders', '/raising-right', '/advertise-wth-us']
}
